import { render, staticRenderFns } from "./cont_main.vue?vue&type=template&id=a4d23dd8&scoped=true"
import script from "./cont_main.vue?vue&type=script&lang=js"
export * from "./cont_main.vue?vue&type=script&lang=js"
import style0 from "./cont_main.vue?vue&type=style&index=0&id=a4d23dd8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d23dd8",
  null
  
)

export default component.exports